import React, { useEffect, useRef, useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Search, Close } from "@mui/icons-material";
import { useGridApiContext } from "../utils/PersistedDataGridPro";

export default function VisiteMedicheQuickFilter() {
  const apiRef = useGridApiContext();
  const [text, setText] = useState(() =>
    (apiRef.current.state.filter.filterModel.quickFilterValues || []).join(" "),
  );
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  const apply = (value) =>
    apiRef.current.setQuickFilterValues(
      value.trim().split(/\s+/).filter(Boolean),
    );
  const change = (value) => {
    setText(value);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => apply(value), 500);
  };
  const clear = () => {
    clearTimeout(timer.current);
    setText("");
    apply("");
  };
  return (
    <TextField
      variant="standard"
      placeholder="Cerca..."
      type="search"
      value={text}
      onChange={(event) => change(event.target.value)}
      inputProps={{ "aria-label": "Cerca visite" }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: text ? (
          <IconButton
            size="small"
            aria-label="Cancella ricerca"
            onClick={clear}
          >
            <Close fontSize="small" />
          </IconButton>
        ) : null,
      }}
    />
  );
}
